import { Star } from "lucide-react";

// rating is on a 0-10 scale; rendered as 5 stars with fractional fill.
export function RatingStars({ rating, size = 18, showValue = true, emptyClassName = "text-black/15", valueClassName = "", className = "", testid = "rating-stars" }) {
  if (rating == null || rating === "") return null;
  const num = Number(rating);
  if (Number.isNaN(num)) return null;
  const outOf5 = Math.max(0, Math.min(5, num / 2));
  const stars = [0, 1, 2, 3, 4];
  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid={testid} aria-label={`Puntuación ${num} sobre 10`}>
      <div className="relative inline-flex" style={{ lineHeight: 0 }}>
        <div className="inline-flex">
          {stars.map((i) => <Star key={i} size={size} className={emptyClassName} fill="currentColor" strokeWidth={0} />)}
        </div>
        <div className="absolute top-0 left-0 overflow-hidden" style={{ width: `${(outOf5 / 5) * 100}%` }}>
          <div className="inline-flex" style={{ width: "max-content" }}>
            {stars.map((i) => <Star key={i} size={size} className="text-[#F5B301] shrink-0" fill="currentColor" strokeWidth={0} />)}
          </div>
        </div>
      </div>
      {showValue && <span className={`text-sm font-bold ${valueClassName}`}>{num}<span className="text-xs opacity-70">/10</span></span>}
    </div>
  );
}
